"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleCancelVisitFormToPayloadDataHandler = scheduleCancelVisitFormToPayloadDataHandler;
const dayjs_1 = __importDefault(require("dayjs"));
function scheduleCancelVisitFormToPayloadDataHandler(data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    const now = (0, dayjs_1.default)();
    if (data.action === "SCHEDULE_VISIT") {
        return Object.assign(Object.assign({}, (((_a = data === null || data === void 0 ? void 0 : data.futureAppointment) === null || _a === void 0 ? void 0 : _a.isConflictAllowed) && {
            isConflictAllowed: true,
        })), { form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ action: data.action }, (((_b = data.futureAppointment) === null || _b === void 0 ? void 0 : _b.visitDate) && {
                visitDate: (_c = data.futureAppointment) === null || _c === void 0 ? void 0 : _c.visitDate,
            })), (((_d = data.futureAppointment) === null || _d === void 0 ? void 0 : _d.visitStartTime) && {
                visitStartTime: (_e = data.futureAppointment) === null || _e === void 0 ? void 0 : _e.visitStartTime,
            })), (((_f = data.futureAppointment) === null || _f === void 0 ? void 0 : _f.visitEndTime) && {
                visitEndTime: (_g = data.futureAppointment) === null || _g === void 0 ? void 0 : _g.visitEndTime,
            })), (data.notes && { notes: data.notes })), { offSet: now.utcOffset() }) });
    }
    return {
        form: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ action: data.action }, (data.notes && { notes: data.notes })), (data.visitDate && {
            visitDate: data.visitDate,
        })), (((_h = data.visitToCancel) === null || _h === void 0 ? void 0 : _h.visitStartTime) && {
            visitStartTime: (_j = data.visitToCancel) === null || _j === void 0 ? void 0 : _j.visitStartTime,
        })), (((_k = data.visitToCancel) === null || _k === void 0 ? void 0 : _k.visitEndTime) && {
            visitEndTime: (_l = data.visitToCancel) === null || _l === void 0 ? void 0 : _l.visitEndTime,
        })), (((_m = data.visitToCancel) === null || _m === void 0 ? void 0 : _m.id) && {
            visitToCancel: (_o = data.visitToCancel) === null || _o === void 0 ? void 0 : _o.id,
        })), { offSet: now.utcOffset() }),
    };
}
